<app-header></app-header>
<app-announcement></app-announcement>
<p-confirmDialog></p-confirmDialog>

<!-- Toggle Button Group for Agency/Stations -->
<div class="d-flex justify-content-start my-3">
  <ul class="nav nav-pills agency-station-toggle">
    <li>
      <button
        type="button"
        class="oval-toggle-btn"
        [ngClass]="{'btn-primary': activeTab === 'agency', 'btn-outline-primary': activeTab !== 'agency'}"
        (click)="switchTab('agency')"
      >Agency</button>
    </li>
    <li>
      <button
        type="button"
        class="oval-toggle-btn"
        [ngClass]="{'btn-primary': activeTab === 'stations', 'btn-outline-primary': activeTab !== 'stations'}"
        (click)="switchTab('stations')"
      >Station</button>
    </li>
  </ul>
</div>

<!-- Tab Content -->
<div class="tab-content mt-3">
  <!-- ================== Agency Tab ================== -->
  <div class="tab-pane fade" [ngClass]="{ 'show active': activeTab === 'agency' }">
    <div class="userbtn_main">
      <button type="button" (click)="showAddagencyArea()" class="btn add_internaluserbtn" pButton>
        <i class="fa fa-plus"></i> Add Agency
      </button>
    </div>

    <div *ngIf="ShowInternalUser" class="searchmain">
      <input
        type="text"
        pInputText
        size="50"
        placeholder="Search..."
        class="searchbox"
        [(ngModel)]="internalUserSearch"
        (input)="dtInternal.filterGlobal(internalUserSearch, 'contains')"
      />
      <i class="fa fa-search search_modified"></i>
    </div>


    <div *ngIf="showAddagencyRow" class="addDataInTable">
      <form #myForm="ngForm" (ngSubmit)="onAddNewAgencySubmit(myForm)">
        <!-- your form inputs -->
        <table>
          <tr>
              <td>
                  <div class="addMandatory">
                      <input name="agencyID" type="text" pInputText pKeyFilter="pint" [(ngModel)]="AdminAgency.agencyID" minlength="9" maxlength="9"
                          placeholder="Agency ID" required #sso="ngModel" [pattern]="ssoPattern"
                      />
                  </div>
                  <div style="margin-left: 13px">
                      <span class="input-ErrorField" *ngIf="!duplicateAgency" [ngClass]="(duplicateAgency==true)?'container-hide':'container-unhide'">Duplicate Agency</span>
                      <!-- <span class="input-ErrorField" [ngClass]="(validateSSO==true)?'container-hide':'container-unhide'">Invalid AgencyID</span> -->
                  </div>

              </td>
              <td>
                  <div class="addMandatory">
                      <input name="agencyName" type="text" pInputText [pattern]="namePattern" placeholder="Agency Name" [(ngModel)]="AdminAgency.agencyName"
                          required #firstName="ngModel" maxlength="1000" />
                  </div>
                  <div [ngClass]="(ValidateAgencyName==true)?'container-hide':'container-unhide'">
                      <span class="input-ErrorField" *ngIf="!ValidateAgencyName">Duplicate Agency Name</span>
                      <span class="input-ErrorField" [ngClass]="(validateSSO==true)?'container-hide':'container-unhide'">Invalid Agency Name</span>
                  </div>
              </td>

              <td>
                  <div style="margin-left: -15px">
                      <button type="submit" class="btn btn-success order_buttonicon" [disabled]="disableSubmitbtn">
                          <i class="fa fa-check"></i> Submit
                      </button>
                      <button type="button" (click)="showAddInternalUserRowClose();myForm.reset()" class="btn btn-success order_btncancel">
                          <i class="fa fa-remove"></i> Cancel</button>
                      <div>
                          &nbsp;
                      </div>
                  </div>
              </td>
          </tr>
      </table>

      </form>
    </div>

    <p-table #dtInternal
             [value]="AdminAgency"
             [paginator]="true"
             [rows]="9"
             [globalFilterFields]="['agencyID','agencyName']"
             [tableStyle]="{ 'width': '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th style="width:38px;">
            <i (click)="internalUsersFilterToggle($event)" class="fa fa-fw fa-filter cursorpointer"></i>
          </th>
          <th pSortableColumn="agencyID" style="width:85px; font-weight:900;">
            AgencyID <p-sortIcon field="agencyID"></p-sortIcon>
          </th>
          <th pSortableColumn="agencyName" style="width:160px; font-weight:900;">
            Agency Name <p-sortIcon field="agencyName"></p-sortIcon>
          </th>
          <th style="width:110px; font-weight:900;">Action</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-i="rowIndex">
        <tr>
          <td><!-- optional checkbox or index --></td>

          <td *ngIf="!rowData.isEditable">{{ rowData.agencyID }}</td>
          <td *ngIf="rowData.isEditable">
            <input type="text"
                   [(ngModel)]="rowData.agencyID"
                   name="agencyID{{ i }}"
                   pKeyFilter="int"
                   minlength="8"
                   maxlength="8"
                   (ngModelChange)="checkAgencyIDField(rowData)"
                   required
                   [pattern]="ssoPattern"
                   pInputText />
            <div>
              <span *ngIf="!invalidAgencyID" class="input-ErrorField">Invalid AgencyID</span>
              <span *ngIf="!duplicateSSOEditIN" class="input-ErrorField">Duplicate AgencyID</span>
            </div>
          </td>

          <td *ngIf="!rowData.isEditable">{{ rowData.agencyName }}</td>
          <td *ngIf="rowData.isEditable">
            <input type="text"
                   [(ngModel)]="rowData.agencyName"
                   name="agencyName{{ i }}"
                   maxlength="1000"
                   (ngModelChange)="checkagencyNameCheck(rowData)"
                   pInputText />
            <div>
              <span *ngIf="!invalidInEditFirstName" class="input-ErrorField">Duplicate Agency Name</span>
            </div>
          </td>

            <td>
              <button type="button" pButton pRipple icon="fa fa-pencil" class="ui-button-success"
                (click)="onRowEditSelect(rowData, myForm)"
                [disabled]="disableINeditBtn"></button>
              <button type="button" pButton pRipple icon="fa fa-check" class="ui-button-success"
                *ngIf="rowData.isEditable"
                (click)="onUpdateAgencyRowClick(rowData)"
                [disabled]="disableINUpdateBtn"></button>
              <button type="button" pButton pRipple icon="fa fa-close" class="ui-button-danger"
                *ngIf="rowData.isEditable"
                (click)="onCancelRowClick(rowData)"></button>
            </td>
        </tr>
      </ng-template>

    </p-table>
  </div>

  <!-- ================== Stations Tab ================== -->
  <div class="tab-pane fade" [ngClass]="{ 'show active': activeTab === 'stations' }">
    <div class="userbtn_main">
      <button type="button" (click)="showAddStationArea()" class="btn external_add_internaluserbtn" pButton>
        <i class="fa fa-plus"></i> Add Station
      </button>
    </div>

    <div *ngIf="ShowExternalUser" class="searchmain">
      <input #ExternalUserTableSearch type="text" pInputText size="50" placeholder="Search..." class="searchbox" />
      <i class="fa fa-search search_modified"></i>
    </div>

    <div *ngIf="showAddExternalUserRow" class="addDataInTable">
      <form #myStationForm="ngForm" (ngSubmit)="onAddNewStationSubmit(myStationForm)">
        <!-- your station form inputs -->
        <table style="border-spacing: 1px;border-collapse: collapse;table-layout: inherit;padding: 1px;">
          <tr>
              <td>
                  <div class="addMandatory">
                      <input name="stationID" type="text" pInputText pKeyFilter="pint" [(ngModel)]="Station.stationID" minlength="9" maxlength="9"
                          placeholder="Station ID" required #sso="ngModel" [pattern]="ssoPattern" />

                  </div>
                  <div style="margin-left: 13px">
                      <span class="input-ErrorField" *ngIf="!duplicateAdvertiser" [ngClass]="(duplicateAdvertiser==true)?'container-hide':'container-unhide'">Duplicate StationID</span>
                      <span class="input-ErrorField" [ngClass]="(validateSSO==true)?'container-hide':'container-unhide'">Invalid stationID</span>
                  </div>

              </td>

              <td>
                  <div class="addMandatory">
                      <input name="stationName" type="text" pInputText [pattern]="ssoPattern" placeholder="Station Name" [(ngModel)]="Station.stationName"
                          maxlength="40" required #advertiserName="ngModel">
                  </div>
                  <div [ngClass]="(ValidateExLastName==true)?'container-hide':'container-unhide'">
                      <span class="input-ErrorField">Duplicate Station Name</span>
                  </div>
              </td>
              <td>
                  <div class="addMandatory">
                      <input name="stationGroupName" type="text" pInputText [pattern]="ssoPattern" placeholder="Station GroupName" [(ngModel)]="Station.stationGroupName"
                          maxlength="40" required #advertiserName="ngModel">
                  </div>
                  <div [ngClass]="(ValidatestationGroupName==true)?'container-hide':'container-unhide'">
                      <span class="input-ErrorField">Duplicate Station GroupName</span>
                  </div>
              </td>
              <td>
                    <button pButton type="submit" class="ui-button-success">
                   Submit
                    </button>
                    <button pButton type="button" (click)="showAddExternalUserRowClose();myStationForm.reset()" class="ui-button-success">
                     Cancel
                    </button>
                  <div>
                      &nbsp;
                  </div>
              </td>
          </tr>
      </table>

      </form>
    </div>

    <p-table #dtExternal
    [value]="Station"
    [paginator]="true"
    [rows]="9"
    [globalFilterFields]="['stationID','stationName','stationGroupName']"
    [(selection)]="selectedExternalUsers"
    selectionMode="single"
    (onRowSelect)="onExternalUserRowSelect(selectedExternalUsers)"
    (onRowUnselect)="onExternalUserRowUnSelect(selectedExternalUsers)"
    [tableStyle]="{ 'width': '100%' }">

<!-- Table Header -->
<ng-template pTemplate="header">
<tr>
 <!-- <th style="width:38px;">
   <i class="fa fa-fw fa-filter cursorpointer"></i>
 </th> -->
 <th pSortableColumn="stationID" style="width:120px; font-weight:900;">
   Station ID <p-sortIcon field="stationID"></p-sortIcon>
 </th>
 <th pSortableColumn="stationName" style="width:200px; font-weight:900;">
   Station Name <p-sortIcon field="stationName"></p-sortIcon>
 </th>
 <th pSortableColumn="stationGroupName" style="width:200px; font-weight:900;">
   Group Name <p-sortIcon field="stationGroupName"></p-sortIcon>
 </th>
 <th style="width:110px; font-weight:900;">Action</th>
</tr>
</ng-template>

<!-- Table Body -->
<ng-template pTemplate="body" let-rowData let-i="rowIndex">
<tr>
 <!-- <td>
  
 </td> -->

 <!-- Station ID -->
 <td *ngIf="!rowData.isEditable">{{ rowData.stationID }}</td>
 <td *ngIf="rowData.isEditable">
   <input type="text"
          [(ngModel)]="rowData.stationID"
          name="stationID{{ i }}"
          pKeyFilter="int"
          minlength="6"
          maxlength="10"
          required
          pInputText />
 </td>

 <!-- Station Name -->
 <td *ngIf="!rowData.isEditable">{{ rowData.stationName }}</td>
 <td *ngIf="rowData.isEditable">
   <input type="text"
          [(ngModel)]="rowData.stationName"
          name="stationName{{ i }}"
          maxlength="255"
          required
          pInputText />
 </td>

 <!-- Group Name -->
 <td *ngIf="!rowData.isEditable">{{ rowData.stationGroupName }}</td>
 <td *ngIf="rowData.isEditable">
   <input type="text"
          [(ngModel)]="rowData.stationGroupName"
          name="stationGroupName{{ i }}"
          maxlength="255"
          pInputText />
 </td>

 <!-- Action Buttons -->
 <td>
   <button pButton icon="fa fa-pencil" class="ui-button-success"
           (click)="onRowEditSelect(rowData, myStationForm)"
           [disabled]="disableEXeditBtn"></button>

   <button pButton icon="fa fa-check" class="ui-button-success"
           *ngIf="rowData.isEditable"
           (click)="onUpdateStationRowClick(rowData)"
           [disabled]="disableEXUpdateBtn"></button>

   <button pButton icon="fa fa-close" class="ui-button-danger"
           *ngIf="rowData.isEditable"
           (click)="onCancelExternalRowClick(rowData)"></button>

           </tr>
</ng-template>
</p-table>
  </div>
</div>
